import { render, staticRenderFns } from "./ArticleNotifyModal.vue?vue&type=template&id=1ba45a32&scoped=true&"
import script from "./ArticleNotifyModal.vue?vue&type=script&lang=js&"
export * from "./ArticleNotifyModal.vue?vue&type=script&lang=js&"
import style0 from "./ArticleNotifyModal.vue?vue&type=style&index=0&id=1ba45a32&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba45a32",
  null
  
)

export default component.exports